// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__QZRtE","errors":"Errors_errors__38cXU"};